var _a;
import { InjectionToken } from '@angular/core';
import LANG_RU_TRANS from '../../../../../../../public/i18n/admin/ru.json';
import LANG_EN_TRANS from '../../../../../../../public/i18n/admin/en.json';
// Временный фикс. Удаляю переводы с unicode символом 2028, из-за которого падает ошибка
delete LANG_RU_TRANS['dashboard']['domains']['reg manual']['intro'];
delete LANG_RU_TRANS['constructor']['orderForm']['def']['phone example'];
delete LANG_EN_TRANS['dashboard']['domains']['reg manual']['intro'];
delete LANG_EN_TRANS['constructor']['orderForm']['def']['phone example'];
// translation token
export var TRANSLATIONS = new InjectionToken('translations');
// all translations
export var dictionary = (_a = {},
    _a['ru'] = LANG_RU_TRANS,
    _a['en'] = LANG_EN_TRANS,
    _a['pt-BR'] = LANG_RU_TRANS,
    _a['ro'] = LANG_RU_TRANS,
    _a['pl'] = LANG_RU_TRANS,
    _a['tr'] = LANG_RU_TRANS,
    _a);
// providers
export var TRANSLATION_PROVIDERS = [
    { provide: TRANSLATIONS, useValue: dictionary }
];
